import type { uzB12Deals } from "./uz-b12-deals";

/** Brief 12, `Bitimlar`, in Russian. */
export const ruB12Deals: Record<keyof typeof uzB12Deals, string> = {
  "deals.title": "Сделки",
  "deals.readOnly": "Только просмотр",
  "deals.filter.idle": "Сделки без движения",
  "deals.head.open": "{count} открыто",
  "deals.head.mine": "мои сделки",
  "deals.head.branch": "филиал {branch}",
  "deals.view.label": "Вид",
  "deals.view.kanban": "Канбан",
  "deals.view.list": "Список",
  "deals.new": "Новая сделка",
  "deals.search.placeholder": "Клиент, № сделки или направление",
  "deals.search.label": "Поиск по сделкам",
  "deals.filter.owner": "Ответственный",
  "deals.filter.branch": "Филиал",
  "deals.filter.all": "Все",
  "deals.filter.lost": "Потерянные",
  "deals.filter.empty": "Нет сделок по этому фильтру",
  "deals.filter.reset": "Сбросить фильтр",
  "deals.empty.title": "Сделок пока нет",
  "deals.empty.body": "Сделка создаётся из обращения или вручную. Этапы воронки находятся в настройках.",
  "deals.empty.action": "К обращениям",
  "deals.error.title": "Сделки не загрузились",
  "deals.board.lostColumn": "Потеряно",
  "deals.board.noDeals": "Нет сделок",
  "deals.board.systemStage": "Системный этап",
  "deals.board.addStage": "Добавить этап",
  "deals.board.pickStage": "Этап",
  "deals.card.idle": "Без движения {days} дн.",
  "deals.card.pax": "{count} чел.",
  "deals.due.today": "Сегодня",
  "deals.due.yesterday": "Вчера",
  "deals.lead.hot": "Горячий",
  "deals.lead.warm": "Тёплый",
  "deals.lead.cold": "Холодный",
  "deals.move.refused": "Не удалось изменить этап",
  "deals.move.failed": "Не перешла на этап «{stage}»: нет связи. Карточка возвращена на место.",
  "deals.move.done": "№{id} · {stage}",
  "deals.move.lost": "№{id} потеряна · причина: {reason}",
  "deals.list.number": "Сделка",
  "deals.list.client": "Клиент",
  "deals.list.destination": "Направление",
  "deals.list.stage": "Этап",
  "deals.list.sum": "Сумма",
  "deals.list.rest": "Остаток",
  "deals.list.owner": "Ответственный",
  "deals.list.due": "Срок",
  "deals.list.label": "Список сделок",
  "deals.list.previous": "Назад",
  "deals.list.next": "Вперёд",
  "deals.panel.number": "Сделка №{id}",
  "deals.panel.open": "Открыть полностью",
  "deals.panel.next": "Перевести на этап «{stage}»",
  "deals.panel.chat": "Переписка",
  "deals.panel.pay": "Внести платёж",
  "deals.panel.lose": "Потеряна",
  "deals.panel.lost": "Потеряна",
  "deals.panel.ai": "Kapitan AI · кратко",
  "deals.panel.money": "Деньги",
  "deals.panel.total": "Всего",
  "deals.panel.paid": "Оплачено",
  "deals.panel.rest": "Остаток",
  "deals.panel.tour": "Тур",
  "deals.panel.destination": "Направление",
  "deals.panel.dates": "Даты",
  "deals.panel.tourists": "Туристы",
  "deals.panel.hotel": "Отель",
  "deals.panel.hotelNone": "Не выбран",
  "deals.panel.owner": "Ответственный",
  "deals.panel.source": "Источник",
  "deals.panel.lostReason": "Причина потери",
  "deals.panel.bookings": "Брони",
  "deals.panel.bookingsAll": "Все",
  "deals.panel.noBooking": "Брони ещё нет",
  "deals.panel.searchTour": "Искать тур",
  "deals.panel.missing": "Сделка не найдена или вам недоступна.",
  "deals.panel.back": "К сделкам",
  "deals.panel.loadError": "Не удалось загрузить сделку",
  "deals.loss.title": "Почему потеряна?",
  "deals.loss.subtitle": "№{id} · {name}. Причина попадает в график потерь в отчётах.",
  "deals.loss.state": "Итоговое состояние",
  "deals.loss.comment": "Комментарий",
  "deals.loss.commentHint": "Что случилось",
  "deals.loss.confirm": "Отметить как потерянную",
  "deals.loss.cancel": "Отмена",
  "deals.new.title": "Новая сделка",
  "deals.new.client": "Клиент",
  "deals.new.clientHint": "Имя или телефон",
  "deals.new.clientRequired": "Укажите клиента",
  "deals.new.clientNew": "Новый клиент: {name}",
  "deals.new.name": "Имя клиента",
  "deals.new.nameRequired": "Укажите имя нового клиента",
  "deals.new.destination": "Направление",
  "deals.new.destinationHint": "Например, Турция · Анталья",
  "deals.new.dates": "Даты",
  "deals.new.dateFrom": "Дата начала",
  "deals.new.dateTo": "Дата окончания",
  "deals.new.pax": "Человек",
  "deals.new.source": "Источник",
  "deals.new.cancel": "Отмена",
  "deals.new.save": "Сохранить",
  "deals.new.created": "Сделка №{id} создана",
  "deals.new.failed": "Не удалось сохранить сделку",
  "deals.stage.title": "Добавить этап",
  "deals.stage.name": "Название этапа",
  "deals.stage.hint": "Например, Пришёл в офис. Этапы агентства стоят перед «Бронью».",
  "deals.stage.save": "Добавить",
  "deals.stage.failed": "Не удалось добавить этап",
  "deals.source.telegram": "Telegram",
  "deals.source.instagram_dm": "Instagram",
  "deals.source.instagram_comment": "Комментарий Instagram",
  "deals.source.instagram_ad": "Реклама Instagram",
  "deals.source.phone": "Звонок",
  "deals.source.walk_in": "Пришёл в офис",
  "deals.source.referral": "Рекомендация",
  "deals.source.website": "Сайт",
};
